import Image from 'next/image';
import { Typography, type TypographyOwnProps } from '@mui/material';
import StarSvg from '@/images/icons/star.svg';
import FlexBox from '@/components/FlexBox';
import theme from '@/app/theme';

const Star = ({ width, height }: { width: number; height: number }) => {
  return <Image src={StarSvg.src} width={width} height={height} alt="별점" />;
};

const ReviewScore = ({
  starWidth = 14,
  starHeight = 13,
  score,
  textVariant = 'body1'
}: {
  starWidth?: number;
  starHeight?: number;
  score: number;
  textVariant?: TypographyOwnProps['variant'];
  starColor?: string;
}) => {
  return (
    <FlexBox style={{ justifyContent: 'start' }}>
      <Star width={starWidth} height={starHeight} />
      <Typography variant={textVariant} color={score > -1 ? theme.palette.gray[900] : theme.palette.error.main} marginLeft={'4px'}>
        {score}
      </Typography>
    </FlexBox>
  );
};

export default ReviewScore;
